import styled from '@emotion/styled';
import { css } from '@emotion/react';
import { Link } from 'react-router-dom';

import { linkWithUnderlineHover } from 'styles/mixins';

interface SocialListProps {
  color?: string | undefined;
  isBlock?: boolean | undefined;
}

const List = styled.ul<SocialListProps>`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 1rem;
  margin: 0 0 2rem;
  padding: 0;
  list-style: none;

  ${(props) => props.color === 'primary' && css`
    color: ${props.theme.mainColors.primary};
  `};
  ${(props) => props.color === 'secondary' && css`
    color: ${props.theme.mainColors.secondary};
  `};
  ${(props) => props.isBlock && css`
    flex-direction: column;
    align-items: unset;
  `};
`;

const ListItem = styled.li<SocialListProps>`
  ${(props) => props.color === 'primary' && css`
    color: ${props.theme.mainColors.primary};
  `};
  ${(props) => props.color === 'secondary' && css`
    color: ${props.theme.mainColors.secondary};
  `};
  ${(props) => props.color === 'black' && css`
    color: ${props.theme.colorMono.black};
  `};
`;

const ListItemLink = styled(Link)`
  display: flex;
  align-items: center;
  gap: .5rem;

  span {
    ${linkWithUnderlineHover('&', 1)};
  }

  svg {
    width: 2.5rem;
    height: 2.5rem;
  }
`;

export {
  List,
  ListItem,
  ListItemLink
};
